export default {"src":"/_next/static/media/loading-logo.93c77b1a.svg","height":160,"width":160};